import { CardFilterView } from "./components/CardFilterView";
import { CardText } from "./components/CardText";
import type { CardFilter } from "./types";

type Props = {
  title: string;
  subtitle?: string;
  isLoading?: boolean;
  filters?: CardFilter[];
  children: React.ReactNode;
};

export const CardView: React.FC<Props> = ({
  title,
  subtitle,
  isLoading,
  filters,
  children,
}) => {
  return (
    <div className="flex h-full flex-col rounded-xl bg-white p-[20px]">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <CardText title={title} subtitle={subtitle} />
        <div className="flex flex-wrap items-center gap-[8.25px]">
          {!isLoading &&
            filters?.map((filter, i) => (
              <CardFilterView key={i} filter={filter} />
            ))}
        </div>
      </div>
      <div className="flex flex-1 flex-col">{children}</div>
    </div>
  );
};
